import { useMemo } from 'react';

export const useRegexp = (expression: string) =>
  useMemo(() => new RegExp(expression), [expression]);
